import React, { Component } from 'react';

// TODO: make as HOC withCountdown
const withCountdown = (WrappedComponent, countdownStart) => {
    return class HOC extends Component {
        constructor(props) {
            super(props);

            this.state = {
                secondsLeft: countdownStart,
            };
        }

        componentDidMount() {
            this.startCountdown();
        }

        startCountdown = () => {
            this.countdown = setInterval(() => {
                this.tick();
            }, 1000);
        };

        tick = () => {
            this.setState(prevState => {
                if (prevState.secondsLeft === -1) return;
                return {
                    secondsLeft: --prevState.secondsLeft,
                };
            });
        };

        componentWillUnmount() {
            clearInterval(this.countdown);
        }

        render() {
            const { secondsLeft } = this.state;
            return <WrappedComponent {...this.props} secondsLeft={secondsLeft} />;
        }
    };
};

export default withCountdown;



// WEBPACK FOOTER //
// ./src/UI/Containers/HOCS/withCountdown/index.js